<template>
  <div
    :class="
      customerClass ? customerClass + ' custom-container' : 'custom-container'
    "
  >
    <div class="forbruk">
      <div class="forbruk_label">Forbruk</div>
      <div class="select-wrap">
        <v-select
          :items="contracts"
          v-model="selectedContract"
          item-value="id"
          hide-details
          solo
        >
          <template slot="selection" slot-scope="{ item }">
            {{ item.street }} {{ item.house }}
          </template>
          <template slot="item" slot-scope="{ item }">
            {{ item.street }} {{ item.house }}, {{ item.city }} -
            {{ item.ap }}
          </template>
        </v-select>
      </div>

      <div class="forbruk-info">
        <DatePicker class="info-item" v-on:getSelectedDate="getComsumption" />

        <template v-if="!$vuetify.breakpoint.smAndDown">
          <div class="info-item compare">
            <div class="compare-item current primary white--text">
              <div class="date">{{ formatedDate }}</div>
              <div class="value">{{ total }} kWh</div>
              <div class="value">{{ calculationTotal }} kr</div>
            </div>
          </div>
          <div class="info-item compare">
            <div class="compare-item current primary white--text">
              <div class="date">{{ formatedDateLastYear }}</div>
              <div class="value">{{ totalLastYear }} kWh</div>
              <div class="value">{{ calculationTotalLastYear }} kr</div>
            </div>
          </div>
        </template>
        <template v-else> </template>
      </div>

      <div
        class="graph-controls"
        :style="!$vuetify.breakpoint.smAndDown ? '' : 'margin-top:15px;'"
      >
        <div class="axis-type-select">
          <div
            :class="
              selectedAxisType === 1
                ? 'active axis-type-item primary white--text'
                : 'axis-type-item'
            "
            @click="
              selectedAxisType = 1;
              parseData();
            "
          >
            kWh
          </div>
          <div
            :class="
              selectedAxisType === 2
                ? 'active axis-type-item primary white--text'
                : 'axis-type-item'
            "
            @click="
              selectedAxisType = 2;
              parseData();
            "
          >
            NOK
          </div>
        </div>
        <div class="ml-5">
          <template v-if="!$vuetify.breakpoint.smAndDown">
            <div class="d-flex flex-direction-row align-baseline">
              <div>
                <v-switch
                  v-model="showPrices"
                  inset
                  hide-details
                  color="primary"
                  class="mt-0 pt-0"
                  v-on:change="parseData()"
                ></v-switch>
              </div>
              <div class="text--primary mr-3 text-left">
                <div>Vis pris per kWh</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="d-flex flex-direction-row align-center">
              <div class="text--primary mr-3 text-left">
                <div>Pris kWh</div>
              </div>
              <v-switch
                v-model="showPrices"
                inset
                hide-details
                color="primary"
                class="mt-0 pt-0"
                v-on:change="parseData()"
              ></v-switch>
            </div>
          </template>
        </div>
      </div>

      <div class="text-left mt-2">
        <span v-if="vatIncluded" class="vat"
          >Priser og beløp vises inkl mva</span
        ><span v-else class="vat">Priser og beløp vises eks mva</span>
      </div>

      <div class="text-left mt-2" v-if="calcNotSupported">
        <span class="vat">Beløp på timesnivå er ikke tilgjengelig enda.</span>
      </div>

      <div v-if="loader" class="loading-widget-layout">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <div v-else class="statistic-widget">
        <div class="statistic-container">
          <VueApexCharts
            type="line"
            height="350"
            :options="chartOptions"
            :series="series"
          ></VueApexCharts>
          <div class="date">{{ selectedAgg }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import DatePicker from "../../components/DatePicker/DatePicker";

import {
  consumption,
  consumptionCalculation,
  getPrices,
} from "../../api/common";
import { getNorwayMonth, convertDateStrEncoded } from "../../utils/date";
import "./Forbruk.scss";

export default {
  name: "Forbruk",

  components: { VueApexCharts, DatePicker },

  data() {
    return {
      calcNotSupported: false,
      vatIncluded: false,
      paramsData: { data: { consumptions: [] } },
      lastYearParamsData: { data: { consumptions: [] } },
      calculationParamsData: { data: { calculations: [] } },
      lastYearCalculationParamsData: { data: { calculations: [] } },
      showPrices: true,
      vat: 25,
      selectedAxisType: 1,
      calculationTotal: 0,
      calculationLastYearTotal: 0,
      calculationTotalLastYear: 0,
      loader: false,
      formatedDate: "",
      formatedDateLastYear: "",
      customerClass: "",
      total: 0,
      totalLastYear: 0,
      currentData: "",
      selectedUnit: "kWh",
      series: [],
      selectedAgg: "Dato",
      chartDates: [],
      chartOptions: {
        legend: {
          show: true,
          labels: {},
          markers: {
            // fillColors: ["#ffc000", "#ca0000"],
          },
        },
        chart: {
          type: "line",
          height: 350,
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          line: {
            horizontal: false,
            columnWidth: "50%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          lineCap: "round",
          width: [0, 3],
        },
        xaxis: {
          categories: [],
        },
        yaxis: [
          {
            title: {
              text: "Forbruk",
            },
          },
          {
            opposite: true,
            title: {
              text: "Pris",
            },
          },
        ],
        fill: {
          opacity: 1,
        },
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex }) => {
            let dateLabel = this.getSeriesPointDate(dataPointIndex);

            switch (this.selectedAxisType) {
              case 1:
                if (this.showPrices) {
                  return this.chartDates.length
                    ? "<div class='chart-tip'><div class='text-left'>" +
                        dateLabel +
                        "</div><div class='text-left'><b>" +
                        (this.chartDates[dataPointIndex] || "") +
                        "</b> - <span class='value'>Forbruk: " +
                        (series[0][dataPointIndex] || "") +
                        " kWh</span></div><div class='text-left'><b>" +
                        (this.chartDates[dataPointIndex] || "") +
                        "</b> - <span class='value'>Pris: " +
                        (series[1][dataPointIndex] || "") +
                        " øre</span></div></div>"
                    : "<div class='chart-tip'><div class='text-left'>" +
                        dateLabel +
                        "</div><div class='text-left'><span class='value'> Forbruk: " +
                        (series[0][dataPointIndex] || "") +
                        " kWh</span></div><div class='text-left'><span class='value'> Pris: " +
                        (series[1][dataPointIndex] || "") +
                        " øre</span></div></div>";
                } else {
                  return this.chartDates.length
                    ? "<div class='chart-tip'><div class='text-left'>" +
                        dateLabel +
                        "</div><div class='text-left'><b>" +
                        (this.chartDates[dataPointIndex] || "") +
                        "</b> - <span class='value'>Forbruk: " +
                        (series[seriesIndex][dataPointIndex] || "") +
                        " kWh</span></div></div>"
                    : "<div class='chart-tip'><div class='text-left'>" +
                        dateLabel +
                        "</div><div class='text-left'><span class='value'> Forbruk: " +
                        (series[seriesIndex][dataPointIndex] || "") +
                        " kWh</span></div></div>";
                }
              case 2:
                if (this.showPrices) {
                  return this.chartDates.length
                    ? "<div class='chart-tip'><div class='text-left'>" +
                        dateLabel +
                        "</div><div class='text-left'><b>" +
                        (this.chartDates[dataPointIndex] || "") +
                        "</b> - <span class='value'>Forbruk: " +
                        (series[0][dataPointIndex] || "") +
                        " NOK</span></div><div class='text-left'><b>" +
                        (this.chartDates[dataPointIndex] || "") +
                        "</b> - <span class='value'>Pris: " +
                        (series[1][dataPointIndex] || "") +
                        " øre</span></div></div>"
                    : "<div class='chart-tip'><div class='text-left'>" +
                        dateLabel +
                        "</div><div class='text-left'><span class='value'> Forbruk: " +
                        (series[0][dataPointIndex] || "") +
                        " NOK</span></div><div class='text-left'><span class='value'> Pris: " +
                        (series[1][dataPointIndex] || "") +
                        " øre</span></div></div>";
                } else {
                  return this.chartDates.length
                    ? "<div class='chart-tip'><div class='text-left'>" +
                        dateLabel +
                        "</div><div class='text-left'><b>" +
                        (this.chartDates[dataPointIndex] || "") +
                        "</b> - <span class='value'>Forbruk: " +
                        (series[seriesIndex][dataPointIndex] || "") +
                        " NOK</span></div></div>"
                    : "<div class='chart-tip'><div class='text-left'>" +
                        dateLabel +
                        "</div><div class='text-left'><span class='value'> Forbruk: " +
                        (series[seriesIndex][dataPointIndex] || "") +
                        " NOK</span></div></div>";
                }
            }
          },
        },
      },
    };
  },

  async mounted() {
    this.chartOptions.fill.colors = [this.$vuetify.theme.themes.light.primary];
    this.chartOptions.stroke.colors = [
      this.$vuetify.theme.themes.light.secondary,
    ];
    this.chartOptions.legend.markers.fillColors = [
      this.$vuetify.theme.themes.light.primary,
      this.$vuetify.theme.themes.light.secondary,
    ];

    if (
      this.$router &&
      this.$router.currentRoute &&
      this.$router.currentRoute.params &&
      this.$router.currentRoute.params.guid
    ) {
      this.selectedContract = this.$router.currentRoute.params.guid;
    }

    if (this.selectedContract) {
      this.selectedMetringPoint =
        this.selectedContract.AccountingPointIdentification;

      await this.getComsumption();
    }
  },

  computed: {
    formatedContracts() {
      return this.$store.getters["getFormatedContracts"];
    },

    contracts() {
      return this.$store.getters["getContracts"];
    },

    selectedContract: {
      get() {
        return this.$store.getters["getSelectedContract"];
      },

      set(value) {
        let contract = this.contracts.find((item) => {
          return item.id === value;
        });

        if (contract) {
          this.$store.commit("setSelectedContract", contract);
        }
      },
    },

    guid() {
      return this.$store.getters["getGuid"];
    },

    user() {
      return this.$store.getters["getUser"];
    },
  },

  watch: {
    async selectedContract(contract) {
      this.selectedMetringPoint = contract.AccountingPointIdentification;
      await this.getComsumption();
    },
  },

  methods: {
    getSeriesPointDate(pointIndex) {
      try {
        let data = this.paramsData.data.consumptions || [];
        let calculationsData =
          this.calculationParamsData.data.calculations || [];
        let selectedDataSet;

        switch (this.selectedAxisType) {
          case 1:
            selectedDataSet = data;
            break;
          case 2:
            selectedDataSet = calculationsData;
            break;
        }

        let item = selectedDataSet[pointIndex];
        let itemDate;

        if (this.requestData.agg === "d") {
          let fallbackDay =
            pointIndex + 1 < 10 ? "0" + (pointIndex + 1) : pointIndex + 1;

          if (this.currentData) {
            itemDate = this.$moment(this.currentData);
          } else {
            itemDate = this.$moment(item.startTime || item.start);
          }

          return (
            fallbackDay +
            " " +
            getNorwayMonth(itemDate.month()) +
            " " +
            itemDate.format("YYYY")
          );
        }

        if (this.requestData.agg === "h") {
          let fallbackHour =
            pointIndex < 10 ? "0" + pointIndex + ":00" : pointIndex + ":00";
          let fallbackHourNext =
            pointIndex + 1 < 11
              ? "0" + (pointIndex + 1) + ":00"
              : pointIndex + 1 + ":00";

          if (this.currentData) {
            itemDate = this.$moment(this.currentData);
            return (
              fallbackHour +
              " - " +
              fallbackHourNext +
              " " +
              itemDate.format("DD") +
              " " +
              getNorwayMonth(itemDate.month())
            );
          } else {
            itemDate = this.$moment(item.startTime || item.start);
            return (
              fallbackHour +
              " - " +
              fallbackHourNext +
              " " +
              itemDate.format("DD") +
              " " +
              getNorwayMonth(itemDate.month())
            );
          }
        }

        if (this.requestData.agg === "m") {
          let fallbackMonth =
            pointIndex + 1 < 10 ? "0" + (pointIndex + 1) : pointIndex + 1;

          if (this.currentData) {
            itemDate = this.$moment(this.currentData);
          } else {
            itemDate = this.$moment(item.startTime || item.start);
          }

          return (
            getNorwayMonth(parseInt(fallbackMonth) - 1) +
            " " +
            itemDate.format("YYYY")
          );
        }
      } catch (e) {
        let fallbackDate = this.$moment();
        let fallbackDay =
          pointIndex + 1 < 10 ? "0" + (pointIndex + 1) : pointIndex + 1;
        let fallbackHour =
          pointIndex < 10 ? "0" + pointIndex + ":00" : pointIndex + ":00";
        let fallbackHourNext =
          pointIndex + 1 < 10
            ? "0" + (pointIndex + 1) + ":00"
            : pointIndex + 1 + ":00";
        let fallbackMonth =
          pointIndex + 1 < 10 ? "0" + (pointIndex + 1) : pointIndex + 1;

        if (this.requestData.agg === "d") {
          return (
            fallbackDay +
            " " +
            getNorwayMonth(fallbackDate.month()) +
            " " +
            fallbackDate.format("YYYY")
          );
        }

        if (this.requestData.agg === "h") {
          return fallbackHour + " - " + fallbackHourNext;
        }

        if (this.requestData.agg === "m") {
          return (
            getNorwayMonth(parseInt(fallbackMonth) - 1) +
            " " +
            fallbackDate.format("YYYY")
          );
        }
      }

      return "";
    },

    getMonth(month) {
      return getNorwayMonth(month);
    },

    getParams(data, lastYear) {
      let startDate, endDate;

      if (!this.selectedMetringPoint) {
        return;
      }

      if (data) {
        if (data.requestedDate) {
          let tmpRequestedYear = "",
            tmpRequestedMonth = "",
            tmpRequestedDay = "";

          switch ((data || {}).agg || "") {
            case "h":
              tmpRequestedYear = (data.requestedDate || "").substring(0, 4);
              tmpRequestedMonth = (data.requestedDate || "").substring(4, 6);
              tmpRequestedDay = (data.requestedDate || "").substring(6, 8);
              break;
            case "d":
              tmpRequestedYear = (data.requestedDate || "").substring(0, 4);
              tmpRequestedMonth = (data.requestedDate || "").substring(4, 6);
              break;
            case "m":
              tmpRequestedYear = (data.requestedDate || "").substring(0, 4);
              break;
          }

          data.date = this.$moment(
            tmpRequestedYear +
              (tmpRequestedMonth ? "-" + tmpRequestedMonth : "") +
              (tmpRequestedDay ? "-" + tmpRequestedDay : "")
          );
        } else {
          data.date = data.date ? new Date(data.date) : new Date();
        }
      }

      if ((data || {}).agg === "d") {
        (startDate = this.$moment(data.requestedDate)
          .startOf("month")
          .format("YYYY-MM-DD")),
          (endDate = this.$moment(data.requestedDate)
            .endOf("month")
            .format("YYYY-MM-DD"));

        this.selectedAgg = "Dato";
      }

      if ((data || {}).agg === "h") {
        (startDate = this.$moment(data.requestedDate).format("YYYY-MM-DD")),
          (endDate = this.$moment(data.requestedDate).format("YYYY-MM-DD"));

        this.selectedAgg = "Time";
      }

      if ((data || {}).agg === "m") {
        (startDate = this.$moment(data.requestedDate)
          .startOf("year")
          .format("YYYY-MM-DD")),
          (endDate = this.$moment(data.requestedDate)
            .endOf("year")
            .format("YYYY-MM-DD"));

        this.selectedAgg = "Måned";
      }

      let params = "meteringpoint=" + this.selectedMetringPoint;

      if (startDate && endDate) {
        if (lastYear) {
          params +=
            "&firstDay=" +
            this.$moment(startDate).add(-1, "year").format("YYYY-MM-DD") +
            "&lastDay=" +
            this.$moment(endDate).add(-1, "year").format("YYYY-MM-DD");
        } else {
          params += "&firstDay=" + startDate + "&lastDay=" + endDate;
        }
      }

      if ((data || {}).agg) {
        params += "&agg=" + data.agg;
      }

      return params;
    },

    applyTax(value) {
      let user = this.user;
      this.vatIncluded = false;

      if (user && user.Identification && user.Identification.length == 9) {
        return value;
      } else {
        if (
          this.selectedContract &&
          this.selectedContract.TaxationProfile &&
          this.selectedContract.TaxationProfile.VATCode &&
          this.selectedContract.TaxationProfile.VATCode.toLowerCase().trim() ==
            "s"
        ) {
          this.vatIncluded = true;
          return value + (value * this.vat) / 100;
        }
      }

      return value;
    },

    parseData() {
      let data = this.paramsData.data.consumptions || [];
      let lastYearData = this.lastYearParamsData.data.consumptions || [];
      let calculationsData = this.calculationParamsData.data.calculations || [];
      let lastYearCalculationsData =
        this.lastYearCalculationParamsData.data.calculations || [];
      let request = this.requestData;

      this.series = [];
      this.total = 0;
      this.totalLastYear = 0;
      this.calculationTotal = 0;
      this.calculationTotalLastYear = 0;

      let newData = [
          {
            type: "column",
            name: "Forbruk",
            data: [],
          },
          {
            type: "line",
            name: "Pris",
            data: [],
          },
        ],
        xaxis = [],
        total = 0,
        lastYearTotal = 0,
        calculationTotal = 0,
        calculationLastYearTotal = 0;

      let axisValue = "consumption";
      let selectedDataSet;
      let finalDataSetOne = [];
      let finalDataSetTwo = [];
      let finalAxisData = [];
      let tmpDate = this.currentData
        ? this.$moment(this.currentData)
        : this.$moment();
      this.chartDates = [];

      if (request.agg === "h" && this.selectedAxisType === 2) {
        this.calcNotSupported = true;
      } else {
        this.calcNotSupported = false;
      }

      if (request.agg === "d") {
        let tmpDays = tmpDate.daysInMonth();
        for (let i = 1; i <= tmpDays; i++) {
          finalDataSetOne.push({
            index: i - 1,
            startTime: this.$moment()
              .set({ year: tmpDate.year(), month: tmpDate.month(), date: i })
              .format("YYYY-MM-DD"),
          });
          finalDataSetTwo.push({
            index: i - 1,
            startTime: this.$moment()
              .set({ year: tmpDate.year(), month: tmpDate.month(), date: i })
              .format("YYYY-MM-DD"),
          });
          finalAxisData.push({
            index: i - 1,
            startTime: this.$moment()
              .set({ year: tmpDate.year(), month: tmpDate.month(), date: i })
              .format("YYYY-MM-DD"),
          });
        }
      }

      if (request.agg === "h") {
        for (let i = 1; i <= 24; i++) {
          finalDataSetOne.push({ index: i - 1, sequence: i });
          finalDataSetTwo.push({ index: i - 1, sequence: i });
          finalAxisData.push({ index: i - 1, sequence: i });
          let labelValue = i
            ? i < 11
              ? "0" + (i - 1) + ":00"
              : i - 1 + ":00"
            : "00:00";
          this.chartDates.push(labelValue);
        }
      }

      if (request.agg === "m") {
        for (let i = 1; i <= 12; i++) {
          finalDataSetOne.push({
            index: i - 1,
            startTime: this.$moment(
              tmpDate.year() + "-" + (i < 10 ? "0" + i : "" + i) + "-01"
            ).format("YYYY-MM-DD"),
          });
          finalDataSetTwo.push({
            index: i - 1,
            startTime: this.$moment(
              tmpDate.year() + "-" + (i < 10 ? "0" + i : "" + i) + "-01"
            ).format("YYYY-MM-DD"),
          });
          finalAxisData.push({
            index: i - 1,
            startTime: this.$moment(
              tmpDate.year() + "-" + (i < 10 ? "0" + i : "" + i) + "-01"
            ).format("YYYY-MM-DD"),
          });
        }
      }

      switch (this.selectedAxisType) {
        case 1:
          axisValue = "consumption";
          selectedDataSet = data;
          break;
        case 2:
          axisValue = "amount";
          selectedDataSet = calculationsData;
          break;
      }

      if (request.agg === "d") {
        data.forEach((item) => {
          total += item.consumption;
        });

        let tmpToAssignOne = [];
        let tmpToAssignTwo = [];
        let tmpToAssignAxis = [];

        selectedDataSet.forEach((item) => {
          this.chartDates = [];

          let tmpIndex = finalDataSetOne.filter(
            (subitem) =>
              this.$moment(subitem.startTime).format("DD") ==
              this.$moment(item.startTime || item.start).format("DD")
          );
          if (
            tmpIndex &&
            tmpIndex.length > 0 &&
            (tmpIndex[0].index || tmpIndex[0].index === 0)
          )
            tmpToAssignOne.push({
              index: tmpIndex[0].index,
              value: (this.selectedAxisType === 2
                ? this.applyTax(item[axisValue])
                : item[axisValue] || 0
              ).toFixed(2),
            });
          let tmpAxisIndex = finalAxisData.filter(
            (subitem) =>
              this.$moment(subitem.startTime).format("DD") ==
              this.$moment(item.startTime || item.start).format("DD")
          );
          if (
            tmpAxisIndex &&
            tmpAxisIndex.length > 0 &&
            (tmpAxisIndex[0].index || tmpAxisIndex[0].index === 0)
          )
            tmpToAssignAxis.push({
              index: tmpAxisIndex[0].index,
              value: this.$moment(item.startTime || item.start).format("DD."),
            });
        });

        for (let i = 0; i < tmpToAssignOne.length; i++)
          finalDataSetOne[tmpToAssignOne[i].index] = tmpToAssignOne[i].value;
        for (let i = 0; i < tmpToAssignAxis.length; i++)
          finalAxisData[tmpToAssignAxis[i].index] = tmpToAssignAxis[i].value;

        lastYearData.forEach((item) => {
          lastYearTotal += item.consumption;
        });

        calculationsData.forEach((item) => {
          calculationTotal += item.amount || 0;
          let tmpIndex = finalDataSetTwo.filter(
            (subitem) =>
              this.$moment(subitem.startTime).format("DD") ==
              this.$moment(item.startTime || item.start).format("DD")
          );
          if (
            tmpIndex &&
            tmpIndex.length > 0 &&
            (tmpIndex[0].index || tmpIndex[0].index === 0)
          )
            tmpToAssignTwo.push({
              index: tmpIndex[0].index,
              value: this.applyTax(parseFloat(item.price) * 100).toFixed(2),
            });
        });

        for (let i = 0; i < tmpToAssignTwo.length; i++)
          finalDataSetTwo[tmpToAssignTwo[i].index] = tmpToAssignTwo[i].value;

        lastYearCalculationsData.forEach((item) => {
          calculationLastYearTotal += item.amount || 0;
        });
      }

      if (request.agg === "h") {
        data.forEach((item) => {
          total += item.consumption;
        });

        let tmpToAssignOne = [];
        let tmpToAssignTwo = [];
        let tmpToAssignAxis = [];

        selectedDataSet.forEach((item) => {
          if (item.sequence) {
            let tmpIndex = finalDataSetOne.filter(
              (subitem) => subitem.sequence == item.sequence
            );
            if (
              tmpIndex &&
              tmpIndex.length > 0 &&
              (tmpIndex[0].index || tmpIndex[0].index === 0)
            )
              tmpToAssignOne.push({
                index: tmpIndex[0].index,
                value: (item[axisValue] || 0).toFixed(2),
              });

            let tmpAxisIndex = finalAxisData.filter(
              (subitem) => subitem.sequence == item.sequence
            );
            if (
              tmpAxisIndex &&
              tmpAxisIndex.length > 0 &&
              (tmpAxisIndex[0].index || tmpAxisIndex[0].index === 0)
            ) {
              let labelValue =
                item.sequence < 11
                  ? "0" + (item.sequence - 1) + ":00"
                  : item.sequence - 1 + ":00";
              tmpToAssignAxis.push({
                index: tmpAxisIndex[0].index,
                value: labelValue,
              });
              this.chartDates[tmpAxisIndex[0].index] = labelValue;
            }
          } else {
            let tmpIndex = finalDataSetOne.filter(
              (subitem) =>
                subitem.sequence - 1 ==
                parseInt(
                  this.$moment(item.startTime || item.start).format("HH")
                )
            );
            if (
              tmpIndex &&
              tmpIndex.length > 0 &&
              (tmpIndex[0].index || tmpIndex[0].index === 0)
            )
              tmpToAssignOne.push({
                index: tmpIndex[0].index,
                value: (item[axisValue] || 0).toFixed(2),
              });

            let tmpAxisIndex = finalAxisData.filter(
              (subitem) =>
                subitem.sequence - 1 ==
                parseInt(
                  this.$moment(item.startTime || item.start).format("HH")
                )
            );
            if (
              tmpAxisIndex &&
              tmpAxisIndex.length > 0 &&
              (tmpAxisIndex[0].index || tmpAxisIndex[0].index === 0)
            ) {
              let labelValue = this.$moment(
                item.startTime || item.start
              ).format("HH:mm");
              tmpToAssignAxis.push({
                index: tmpAxisIndex[0].index,
                value: labelValue,
              });
              this.chartDates[tmpAxisIndex[0].index] = labelValue;
            }
          }
        });

        for (let i = 0; i < tmpToAssignOne.length; i++)
          finalDataSetOne[tmpToAssignOne[i].index] = tmpToAssignOne[i].value;
        for (let i = 0; i < tmpToAssignAxis.length; i++)
          finalAxisData[tmpToAssignAxis[i].index] = tmpToAssignAxis[i].value;

        lastYearData.forEach((item) => {
          lastYearTotal += item.consumption;
        });

        calculationsData.forEach((item) => {
          calculationTotal += item.amount || 0;
          let tmpIndex = finalDataSetTwo.filter(
            (subitem) => subitem.sequence == item.sequence
          );
          if (
            tmpIndex &&
            tmpIndex.length > 0 &&
            (tmpIndex[0].index || tmpIndex[0].index === 0)
          )
            tmpToAssignTwo.push({
              index: tmpIndex[0].index,
              value: this.applyTax(parseFloat(item.price) * 100).toFixed(2),
            });
        });

        for (let i = 0; i < tmpToAssignTwo.length; i++)
          finalDataSetTwo[tmpToAssignTwo[i].index] = tmpToAssignTwo[i].value;

        lastYearCalculationsData.forEach((item) => {
          calculationLastYearTotal += item.amount || 0;
        });
      }

      if (request.agg === "m") {
        data.forEach((item) => {
          total += item.consumption;
        });

        let tmpToAssignOne = [];
        let tmpToAssignTwo = [];
        let tmpToAssignAxis = [];

        selectedDataSet.forEach((item) => {
          this.chartDates = [];

          let tmpIndex = finalDataSetOne.filter(
            (subitem) =>
              this.$moment(subitem.startTime).format("MM") ==
              this.$moment(item.startTime || item.start).format("MM")
          );
          if (
            tmpIndex &&
            tmpIndex.length > 0 &&
            (tmpIndex[0].index || tmpIndex[0].index === 0)
          )
            tmpToAssignOne.push({
              index: tmpIndex[0].index,
              value: (item[axisValue] || 0).toFixed(2),
            });
          let tmpAxisIndex = finalAxisData.filter(
            (subitem) =>
              this.$moment(subitem.startTime).format("MM") ==
              this.$moment(item.startTime || item.start).format("MM")
          );
          if (
            tmpAxisIndex &&
            tmpAxisIndex.length > 0 &&
            (tmpAxisIndex[0].index || tmpAxisIndex[0].index === 0)
          ) {
            tmpToAssignAxis.push({
              index: tmpAxisIndex[0].index,
              value: this.$moment(item.startTime || item.start).format(
                "MM.YYYY"
              ),
            });
          }
        });

        for (let i = 0; i < tmpToAssignOne.length; i++)
          finalDataSetOne[tmpToAssignOne[i].index] = tmpToAssignOne[i].value;
        for (let i = 0; i < tmpToAssignAxis.length; i++)
          finalAxisData[tmpToAssignAxis[i].index] = tmpToAssignAxis[i].value;

        lastYearData.forEach((item) => {
          lastYearTotal += item.consumption;
        });

        calculationsData.forEach((item) => {
          calculationTotal += item.amount || 0;
          let tmpIndex = finalDataSetTwo.filter(
            (subitem) =>
              this.$moment(subitem.startTime).format("MM") ==
              this.$moment(item.startTime || item.start).format("MM")
          );
          if (
            tmpIndex &&
            tmpIndex.length > 0 &&
            (tmpIndex[0].index || tmpIndex[0].index === 0)
          )
            tmpToAssignTwo.push({
              index: tmpIndex[0].index,
              value: this.applyTax(parseFloat(item.price) * 100).toFixed(2),
            });
        });

        for (let i = 0; i < tmpToAssignTwo.length; i++)
          finalDataSetTwo[tmpToAssignTwo[i].index] = tmpToAssignTwo[i].value;

        lastYearCalculationsData.forEach((item) => {
          calculationLastYearTotal += item.amount || 0;
        });
      }

      for (let i = 0; i < finalDataSetOne.length; i++)
        if (isNaN(finalDataSetOne[i])) finalDataSetOne[i] = 0;
      for (let i = 0; i < finalDataSetTwo.length; i++)
        if (isNaN(finalDataSetTwo[i])) finalDataSetTwo[i] = 0;

      for (let i = 0; i < finalAxisData.length; i++) {
        if (typeof finalAxisData[i] === "object" && finalAxisData[i] !== null) {
          if (request.agg === "d") {
            finalAxisData[i] = this.$moment(
              finalAxisData[i].startTime || finalAxisData[i].start
            ).format("DD.");
          }

          if (request.agg === "h") {
            let labelValue = finalAxisData[i].sequence
              ? finalAxisData[i].sequence < 11
                ? "0" + (finalAxisData[i].sequence - 1) + ":00"
                : finalAxisData[i].sequence - 1 + ":00"
              : this.$moment(
                  finalAxisData[i].startTime || finalAxisData[i].start
                ).format("HH:mm");
            finalAxisData[i] = labelValue;
          }

          if (request.agg === "m") {
            finalAxisData[i] = this.$moment(
              finalAxisData[i].startTime || finalAxisData[i].start
            ).format("MM.YYYY");
          }
        }
      }

      for (let i = 0; i < finalAxisData.length; i++) {
        if (window.innerWidth < 768) {
          if (i === 0 || i % 5 === 0) {
            xaxis.push(finalAxisData[i]);
          } else {
            xaxis.push("");
          }
        } else {
          xaxis.push(finalAxisData[i]);
        }
      }

      this.chartOptions = Object.assign({}, this.chartOptions, {
        xaxis: {
          categories: xaxis,
        },
      });

      if (window.innerWidth < 768) {
        this.chartOptions.yaxis = {
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        };
      } else {
        this.chartOptions.yaxis = [
          {
            title: {
              text: "Forbruk",
            },
          },
          {
            opposite: true,
            title: {
              text: "Pris",
            },
          },
        ];
      }

      this.total = total.toFixed(2);
      this.totalLastYear = lastYearTotal.toFixed(2);
      this.calculationTotal = this.applyTax(
        parseFloat(calculationTotal)
      ).toFixed(2);
      this.calculationTotalLastYear = this.applyTax(
        parseFloat(calculationLastYearTotal)
      ).toFixed(2);

      newData[0].data = finalDataSetOne;
      newData[1].data = finalDataSetTwo;

      if (!this.showPrices) {
        newData = [newData[0]];
        this.chartOptions.chart.type = "bar";
      } else {
        this.chartOptions.chart.type = "line";
      }

      this.series = newData;
    },

    async getComsumption(data, formatedDate) {
      // if (this.loader) return;

      this.loader = true;

      try {
        if (data) {
          if (data.requestedDate) {
            let tmpRequestedYear = "",
              tmpRequestedMonth = "",
              tmpRequestedDay = "";

            switch ((data || {}).agg || "") {
              case "h":
                tmpRequestedYear = (data.requestedDate || "").substring(0, 4);
                tmpRequestedMonth = (data.requestedDate || "").substring(4, 6);
                tmpRequestedDay = (data.requestedDate || "").substring(6, 8);
                break;
              case "d":
                tmpRequestedYear = (data.requestedDate || "").substring(0, 4);
                tmpRequestedMonth = (data.requestedDate || "").substring(4, 6);
                break;
              case "m":
                tmpRequestedYear = (data.requestedDate || "").substring(0, 4);
                break;
            }

            data.date = this.$moment(
              tmpRequestedYear +
                (tmpRequestedMonth ? "-" + tmpRequestedMonth : "") +
                (tmpRequestedDay ? "-" + tmpRequestedDay : "")
            );
          }

          this.currentData = data.date;
          this.requestData = Object.assign({}, data);
        }

        let calcHourlyPrices = false;
        let nonFormatedDate = "";
        let nonFormatedDateLastYear = "";

        if (formatedDate) {
          let tmpRequestedYear = "",
            tmpRequestedMonth = "",
            tmpRequestedDay = "";

          switch ((data || {}).agg || "") {
            case "h":
              tmpRequestedYear = (data.requestedDate || "").substring(0, 4);
              tmpRequestedMonth = (data.requestedDate || "").substring(4, 6);
              tmpRequestedDay = (data.requestedDate || "").substring(6, 8);
              break;
            case "d":
              tmpRequestedYear = (data.requestedDate || "").substring(0, 4);
              tmpRequestedMonth = (data.requestedDate || "").substring(4, 6);
              break;
            case "m":
              tmpRequestedYear = (data.requestedDate || "").substring(0, 4);
              break;
          }

          this.formatedDate = formatedDate;
          this.formatedDateLastYear = this.$moment(
            tmpRequestedYear +
              (tmpRequestedMonth ? "-" + tmpRequestedMonth : "") +
              (tmpRequestedDay ? "-" + tmpRequestedDay : "")
          ).add(-1, "year");
          nonFormatedDate = this.$moment(
            tmpRequestedYear +
              (tmpRequestedMonth ? "-" + tmpRequestedMonth : "") +
              (tmpRequestedDay ? "-" + tmpRequestedDay : "")
          );
          nonFormatedDateLastYear = this.$moment(
            tmpRequestedYear +
              (tmpRequestedMonth ? "-" + tmpRequestedMonth : "") +
              (tmpRequestedDay ? "-" + tmpRequestedDay : "")
          ).add(-1, "year");

          switch ((data || {}).agg || "") {
            case "h":
              this.formatedDateLastYear =
                this.formatedDateLastYear.format("DD") +
                " " +
                getNorwayMonth(this.formatedDateLastYear.month()) +
                " " +
                this.formatedDateLastYear.format("YYYY");
              calcHourlyPrices = true;
              break;
            case "d":
              this.formatedDateLastYear =
                getNorwayMonth(this.formatedDateLastYear.month()) +
                " " +
                this.formatedDateLastYear.format("YYYY");
              break;
            case "m":
              this.formatedDateLastYear =
                this.formatedDateLastYear.format("YYYY");
              break;
          }
        } else {
          let tmp = this.$moment(new Date()).add(-1, "year");
          this.formatedDate =
            getNorwayMonth(new Date().getMonth()) +
            " " +
            this.$moment(new Date()).format("YYYY");
          this.formatedDateLastYear =
            getNorwayMonth(tmp.month()) + " " + tmp.format("YYYY");
          nonFormatedDate = this.formatedDate;
          nonFormatedDateLastYear = this.formatedDateLastYear;
        }

        this.total = 0;

        let params = this.getParams(this.requestData, false);
        let lastYearParams = this.getParams(this.requestData, true);

        this.paramsData = { data: { consumptions: [] } };
        this.calculationParamsData = { data: { calculations: [] } };

        if (params) {
          this.paramsData = await consumption(params);
          this.calculationParamsData = await consumptionCalculation(
            params + "&forceFetchData=0&customer=" + this.guid
          );

          if (
            this.paramsData &&
            this.paramsData.data &&
            this.paramsData.data.consumptions
          ) {
            this.paramsData.data.consumptions.sort((a, b) => {
              return new Date(a.endTime) - new Date(b.endTime);
            });
          }

          if (
            this.calculationParamsData &&
            this.calculationParamsData.data &&
            this.calculationParamsData.data.calculations
          ) {
            this.calculationParamsData.data.calculations.sort((a, b) => {
              return new Date(a.end) - new Date(b.end);
            });
          }

          if (calcHourlyPrices) {
            let params = {
              ap: this.selectedContract.AccountingPointIdentification,
              customer: this.guid,
              date: convertDateStrEncoded(
                this.$moment(nonFormatedDate).toISOString()
              ),
            };

            try {
              let tmp = (await getPrices(params)) || {
                data: { consumptionPriceSequenceAggregated: [] },
              };
              if (tmp.data.consumptionPriceSequenceAggregated.length > 0) {
                // consumption kWh
                if (this.paramsData.data.consumptions.length <= 0) {
                  this.paramsData.data.consumptions = [];
                  for (
                    let i = 0;
                    i < tmp.data.consumptionPriceSequenceAggregated.length;
                    i++
                  ) {
                    this.paramsData.data.consumptions.push({
                      consumption: 0,
                      price:
                        tmp.data.consumptionPriceSequenceAggregated[i].price,
                      sequence: i + 1,
                    });
                  }
                }

                // calculation NOK
                if (
                  this.calculationParamsData.data.calculations &&
                  this.calculationParamsData.data.calculations.length > 0
                ) {
                  for (
                    let i = 0;
                    i < tmp.data.consumptionPriceSequenceAggregated.length;
                    i++
                  ) {
                    if (this.calculationParamsData.data.calculations[i]) {
                      this.calculationParamsData.data.calculations[i].price =
                        tmp.data.consumptionPriceSequenceAggregated[i].price;
                    }
                  }
                } else {
                  this.calculationParamsData.data.calculations = [];
                  for (
                    let i = 0;
                    i < tmp.data.consumptionPriceSequenceAggregated.length;
                    i++
                  ) {
                    this.calculationParamsData.data.calculations.push({
                      amount: 0,
                      price:
                        tmp.data.consumptionPriceSequenceAggregated[i].price,
                      sequence: i + 1,
                    });
                  }
                }
              }
            } catch (e) {
              console.log(e);
            }
          }
        }

        this.lastYearParamsData = { data: { consumptions: [] } };
        this.lastYearCalculationParamsData = { data: { calculations: [] } };

        if (lastYearParams) {
          this.lastYearParamsData = await consumption(lastYearParams);
          this.lastYearCalculationParamsData = await consumptionCalculation(
            lastYearParams + "&forceFetchData=0&customer=" + this.guid
          );

          if (
            this.lastYearParamsData &&
            this.lastYearParamsData.data &&
            this.lastYearParamsData.data.consumptions
          ) {
            this.lastYearParamsData.data.consumptions.sort((a, b) => {
              return new Date(a.endTime) - new Date(b.endTime);
            });
          }

          if (
            this.lastYearCalculationParamsData &&
            this.lastYearCalculationParamsData.data &&
            this.lastYearCalculationParamsData.data.calculations
          ) {
            this.lastYearCalculationParamsData.data.calculations.sort(
              (a, b) => {
                return new Date(a.end) - new Date(b.end);
              }
            );
          }

          if (calcHourlyPrices) {
            let params = {
              ap: this.selectedContract.AccountingPointIdentification,
              customer: this.guid,
              date: convertDateStrEncoded(
                this.$moment(nonFormatedDateLastYear).toISOString()
              ),
            };

            try {
              let tmp = (await getPrices(params)) || {
                data: { consumptionPriceSequenceAggregated: [] },
              };

              // consumption kWh
              if (this.lastYearParamsData.data.consumptions.length <= 0) {
                this.lastYearParamsData.data.consumptions = [];
                for (
                  let i = 0;
                  i < tmp.data.consumptionPriceSequenceAggregated.length;
                  i++
                ) {
                  this.lastYearParamsData.data.consumptions.push({
                    consumption: 0,
                    price: tmp.data.consumptionPriceSequenceAggregated[i].price,
                    sequence: i + 1,
                  });
                }
              }

              // calculation NOK
              if (
                this.lastYearCalculationParamsData.data.calculations &&
                this.lastYearCalculationParamsData.data.calculations.length > 0
              ) {
                for (
                  let i = 0;
                  i < tmp.data.consumptionPriceSequenceAggregated.length;
                  i++
                ) {
                  if (this.lastYearCalculationParamsData.data.calculations[i]) {
                    this.lastYearCalculationParamsData.data.calculations[
                      i
                    ].price =
                      tmp.data.consumptionPriceSequenceAggregated[i].price;
                  }
                }
              } else {
                this.lastYearCalculationParamsData.data.calculations = [];
                for (
                  let i = 0;
                  i < tmp.data.consumptionPriceSequenceAggregated.length;
                  i++
                ) {
                  this.lastYearCalculationParamsData.data.calculations.push({
                    amount: 0,
                    price: tmp.data.consumptionPriceSequenceAggregated[i].price,
                    sequence: i + 1,
                  });
                }
              }
            } catch (e) {
              console.log(e);
            }
          }
        }

        this.parseData();
      } catch (error) {
        console.log(error);
      }

      this.loader = false;
    },
  },
};
</script>
